import axios from 'axios';
import {
  axiosUserDataAPI,
  marketDataGateway,
  userData,
  apiGatewayAPI,
} from '@core/market-data-sdk';
import { tokenInterceptor } from '@core/features-core/auth/client';

const axiosInstanceV3 = axios.create({
  baseURL: `${process.env.NEXT_PUBLIC_DATA_API_V3}`,
  headers: {
    Referer: process.env.NEXT_PUBLIC_DOMAIN,
  },
});

const axiosNestJsInstance = axios.create({
  baseURL: `${process.env.NEXT_PUBLIC_NEST_API}`,
  headers: {
    contentType: 'application/json',
    'Cache-Control': 'no-cache, no-store, must-revalidate, max-age=0',
  },
});

const axiosNextApiInstance = axios.create({
  baseURL: `${process.env.NEXT_PUBLIC_DOMAIN}/api/nextjs`,
});

const axiosGraphqlInstance = axios.create({
  baseURL: `${process.env.NEXT_PUBLIC_GRAPHQL_API}`,
});

const axiosPortalInstance = axios.create({
  baseURL: `${process.env.NEXT_PUBLIC_PORTAL_API}`,
});

const AxiosPagarmeInstance = axios.create({
  baseURL: process.env.PAGARME_BASE_URL,
});

AxiosPagarmeInstance.interceptors.request.use((request) => {
  request.auth = {
    username: process.env.PAGARME_SECRET_KEY,
    password: null,
  };

  return request;
});

const axiosPRest = axios.create({
  baseURL: process.env.NEXT_PUBLIC_PREST,
});

const axiosIBGEInstance = axios.create({
  baseURL: 'https://servicodados.ibge.gov.br/api/v1/',
});

const screenerAPI = axios.create({
  baseURL: process.env.NEXT_PUBLIC_SCREENER_API,
});

const screenerSecretAPI = axios.create({
  baseURL: process.env.NEXT_PUBLIC_SCREENER_API?.replace(
    '/screener',
    '/secret/screener'
  ),
});

axiosNestJsInstance.interceptors.request.use(tokenInterceptor);
screenerAPI.interceptors.request.use(tokenInterceptor);
userData.http.interceptors.request.use(tokenInterceptor);
marketDataGateway.http.interceptors.request.use(tokenInterceptor);
axiosUserDataAPI.interceptors.request.use(tokenInterceptor);
apiGatewayAPI.interceptors.request.use(tokenInterceptor);

export {
  axiosInstanceV3,
  axiosNestJsInstance,
  axiosNextApiInstance,
  axiosGraphqlInstance,
  AxiosPagarmeInstance,
  axiosPortalInstance,
  axiosPRest,
  axiosIBGEInstance,
  screenerAPI,
  screenerSecretAPI,
};
